import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import OverviewCards from '../features/monitoring/components/OverviewCards';
import DailyDigestPanel from '../features/monitoring/components/DailyDigestPanel';
import RecentActivityPanel from '../features/monitoring/components/RecentActivityPanel';
import SignupHistoryPanel from '../features/monitoring/components/SignupHistoryPanel';
import SubscribeHistoryPanel from '../features/monitoring/components/SubscribeHistoryPanel';
import SiteHistoryPanel from '../features/monitoring/components/SiteHistoryPanel';
import ApiStatsPanel from '../features/monitoring/components/ApiStatsPanel';
import SlowRequestsPanel from '../features/monitoring/components/SlowRequestsPanel';
import ErrorTrackingPanel from '../features/monitoring/components/ErrorTrackingPanel';
import UserActivityPanel from '../features/monitoring/components/UserActivityPanel';
import {
  SubscribeStatsPanel,
  ExtensionStatsPanel,
  StandardPlanPanel,
} from '../features/monitoring/components/BusinessPanels';
import LambdaLogPanel from '../features/monitoring/components/LambdaLogPanel';

const Container = styled.div`
  min-height: 100vh;
  background: #f5f7fa;
  padding: 24px;
  @media (max-width: 768px) { padding: 12px; }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const Title = styled.h1`font-size: 24px; font-weight: 700; color: #111827; margin: 0;`;

const RefreshBtn = styled.button`
  padding: 8px 16px;
  background: #667eea;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  &:hover { background: #5a6fd6; }
`;

const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 20px;
  @media (max-width: 1000px) { grid-template-columns: 1fr; }
`;

const FullWidth = styled.div`margin-top: 20px;`;

export default function Dashboard() {
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = useCallback(() => setRefreshKey((k) => k + 1), []);

  return (
    <Container>
      <Header>
        <Title>대시보드</Title>
        <RefreshBtn onClick={refresh}>새로고침</RefreshBtn>
      </Header>

      {/* 개요 카드 */}
      <OverviewCards refreshKey={refreshKey} />

      {/* Daily Digest */}
      <FullWidth>
        <DailyDigestPanel refreshKey={refreshKey} />
      </FullWidth>

      {/* 최근 활동 타임라인 */}
      <FullWidth>
        <RecentActivityPanel refreshKey={refreshKey} />
      </FullWidth>

      {/* 서비스 운영 관리 */}
      <Grid2>
        <SignupHistoryPanel refreshKey={refreshKey} />
        <SubscribeHistoryPanel refreshKey={refreshKey} />
      </Grid2>

      <Grid2>
        <SiteHistoryPanel refreshKey={refreshKey} />
        <LambdaLogPanel refreshKey={refreshKey} />
      </Grid2>

      {/* API 모니터링 */}
      <Grid2>
        <ApiStatsPanel refreshKey={refreshKey} />
        <SubscribeStatsPanel refreshKey={refreshKey} />
      </Grid2>

      <Grid2>
        <ErrorTrackingPanel refreshKey={refreshKey} />
        <SlowRequestsPanel refreshKey={refreshKey} />
      </Grid2>

      <Grid2>
        <UserActivityPanel refreshKey={refreshKey} />
        <ExtensionStatsPanel refreshKey={refreshKey} />
      </Grid2>

      <FullWidth>
        <StandardPlanPanel refreshKey={refreshKey} />
      </FullWidth>
    </Container>
  );
}
